import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;
const coreBlue = colors.ui.core[500];
const neutral400 = colors.ui.neutral[400];
const white = colors.ui.white[500];

const borderColor = coreBlue;

const statementWidth = "2fr";
const answerWidth = "1.6fr";
const reasonWidth = "2fr";

export const containerStyles: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "16px",
};

export const tableContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
};

export const headerRow: CSSObject = {
  display: "grid",
  gridTemplateColumns: `${statementWidth} ${answerWidth} ${reasonWidth}`,
  borderBottom: `4px solid ${borderColor}`,
  fontWeight: 700,
  paddingBottom: "8px",
};

export const headerCell: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "end",
  alignItems: "flex-start",
  padding: "8px 8px 0",
  borderRight: `4px solid ${borderColor}`,
  ...typographyStyles.heading6Obj,
};

export const headerCellReason: CSSObject = {
  ...headerCell,
  borderRight: "none",
};

export const dataRow: CSSObject = {
  display: "grid",
  gridTemplateColumns: `${statementWidth} ${answerWidth} ${reasonWidth}`,
  alignItems: "stretch",
  padding: "6px 0",
  borderBottom: `2px solid ${borderColor}`,
  background: white,
  minHeight: "64px",
};

export const cell: CSSObject = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  padding: "0 8px",
  minHeight: "65px",
  background: white,
  borderRight: `4px solid ${borderColor}`,
};

export const cellReason: CSSObject = {
  ...cell,
  borderRight: "none",
};

export const textareaCss: CSSObject = {
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  padding: "8px 12px",
  resize: "none",
  height: "100%",
  maxHeight: "85px",
  overflowY: "hidden",
  width: "100%",
  ...typographyStyles.textMObj,
};

export const paragraphCss: CSSObject = {
  margin: "0",
  padding: "8px 12px",
  maxHeight: "85px",
  ...typographyStyles.textMObj,
};
